import { useState } from "react";
import { Reveal } from "@/components/Reveal";
import { Eyebrow } from "@/components/istituti/Eyebrow";
import { PricingToggle } from "@/components/aziende/PricingToggle";
import { CalcSelect, CalcSlider } from "@/components/aziende/calc/CalcInputs";
import { CalcResults } from "@/components/aziende/calc/CalcResults";
import { CalcClose } from "@/components/aziende/calc/CalcClose";
import { PLANS } from "@/components/aziende/plans";
import { euro } from "@/lib/format";

const ROLES = [
  { id: "it", name: "Sviluppatore IT", ral: 32000 },
  { id: "ing", name: "Ingegnere", ral: 35000 },
  { id: "tec", name: "Tecnico Specializzato", ral: 25000 },
  { id: "sales", name: "Sales/Marketing", ral: 28000 },
  { id: "mgr", name: "Manager", ral: 50000 },
];
const CALC_PLANS = PLANS.filter((p) => p.price && p.contacts);

const DISCLAIMER =
  "Nota bene: I piani Prodigy offrono un tetto massimo di contatti annui (es. 120 per Omega). Sappiamo che 120 contatti non equivalgono a 120 assunzioni, ma il risparmio mostrato si concretizza fin dalla primissima assunzione. Inoltre, Prodigy ti fornisce l'analisi psicometrica e l'archetipo comportamentale dei candidati: dati fondamentali che nessuna agenzia tradizionale o piattaforma è in grado di fornirti.";

export const Calcolatore = ({ pcto, setPcto }) => {
  const [roleId, setRoleId] = useState("it");
  const [planId, setPlanId] = useState("vision");
  const [hires, setHires] = useState(3);
  const role = ROLES.find((r) => r.id === roleId);
  const plan = CALC_PLANS.find((p) => p.id === planId);
  const agency = role.ral * 0.15 * hires;
  const prodigy = pcto ? plan.price.pcto : plan.price.standard;
  const over = hires > plan.contacts;
  const suggestion = over ? CALC_PLANS.find((p) => p.contacts >= hires && p.price.standard > plan.price.standard) : null;

  return (
    <section id="calcolatore" className="relative px-6 py-20 lg:py-36 scroll-mt-24" data-testid="calcolatore-section">
      <div className="max-w-6xl mx-auto">
        <Reveal className="text-center mb-12 lg:mb-16">
          <Eyebrow className="mb-6">Calcolatore ROI</Eyebrow>
          <h2 className="font-extrabold tracking-[-0.04em] leading-[1.04] text-4xl sm:text-5xl lg:text-6xl" data-testid="calc-title">
            Calcola il tuo reale risparmio.
          </h2>
        </Reveal>
        <Reveal>
          <div className="calc-panel glass relative overflow-hidden rounded-[28px] p-6 sm:p-10">
            <div className="calc-grid absolute inset-0 pointer-events-none" />
            <div className="relative grid grid-cols-1 lg:grid-cols-[minmax(0,5fr)_minmax(0,7fr)] gap-10 lg:gap-14">
              <div className="space-y-8">
                <CalcSelect
                  id="calc-role"
                  label="Ruolo Medio Ricercato"
                  value={roleId}
                  onChange={setRoleId}
                  options={ROLES.map((r) => ({ value: r.id, label: `${r.name} (${euro(r.ral)})` }))}
                />
                <CalcSelect
                  id="calc-plan"
                  label="Seleziona Piano Prodigy Simulato"
                  value={planId}
                  onChange={setPlanId}
                  options={CALC_PLANS.map((p) => ({ value: p.id, label: p.name }))}
                />
                <CalcSlider value={hires} onChange={setHires} />
                <PricingToggle pcto={pcto} onChange={setPcto} className="justify-start" testPrefix="calc" />
              </div>
              <div>
                <CalcResults agency={agency} prodigy={prodigy} plan={plan} over={over} suggestion={suggestion} onSuggest={setPlanId} />
                <p className="mt-6 text-xs sm:text-[13px] leading-relaxed text-[#80858d]" data-testid="calc-disclaimer">
                  {DISCLAIMER}
                </p>
              </div>
            </div>
          </div>
        </Reveal>
        <CalcClose diff={agency - prodigy} plan={plan} />
      </div>
    </section>
  );
};
